import http from "@/services/http";

/**
 * Lista os registros ginecológicos de um paciente (tabela patient_gynecology_assessments),
 * mais recente primeiro.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getGynecologyByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-gynecology/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Cria um registro ginecológico.
 * @param {number|string} patientId
 * @param {object} payload { menstrual_status?, is_climacteric?, recorded_at?, notes? }
 */
export function createGynecology(patientId, payload) {
  return http.post("/api/patient-gynecology/create", {
    patient_id: patientId,
    ...payload,
  });
}

/**
 * Atualiza um registro ginecológico existente.
 */
export function updateGynecology(id, payload) {
  return http.put(`/api/patient-gynecology/update/${id}`, payload);
}

/**
 * Remove um registro ginecológico (soft delete).
 */
export function deleteGynecology(id) {
  return http.delete(`/api/patient-gynecology/delete/${id}`);
}
